import React, { useState } from 'react'
import './contact.css'

const Contact = () => {
  const [status, setStatus] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()

    const form = e.target
    const name = form[0].value
    const email = form[1].value
    const message = form[2].value

    if (!name || !email || !message) {
      setStatus('error')
      return
    }

    // Simulate successful submission
    setStatus('success')
    form.reset()

    // Auto hide message after 4 seconds
    setTimeout(() => {
      setStatus(null)
    }, 4000)
  }

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <form onSubmit={handleSubmit}>
          <input type="text" placeholder='Your Full Name' required />
          <input type="email" placeholder='Your Email' required />
          <textarea placeholder='Your Message' rows="7" required></textarea>

          <button type='submit' className='btn btn-primary'>
            Send Message
          </button>

          {status === 'success' && (
            <p className="success-msg">
              ✅ Message sent successfully!
            </p>
          )}

          {status === 'error' && (
            <p className="error-msg">
              ❌ Please fill all fields correctly.
            </p>
          )}
        </form>
      </div>
    </section>
  )
}

export default Contact